/**
 * Web navigation link slot implementation.
 *
 * Maps semantic destinations to URL paths and provides TanStack Router navigation.
 */

import { useLocation, useNavigate } from "@tanstack/react-router";

import type {
  NavLinkSlotProps,
  SidebarDestination,
} from "@animus/dom-features";

const ROUTES: Record<SidebarDestination, string> = {
  home: "/",
  adminDashboard: "/admin",
  adminUsers: "/admin/users",
  adminFoods: "/admin/foods",
  adminModifiers: "/admin/modifiers",
  adminReleases: "/admin/releases",
  adminDebug: "/admin/debug",
};

export function WebNavLink({ destination, children }: NavLinkSlotProps) {
  const routerNavigate = useNavigate();
  const location = useLocation();
  const path = ROUTES[destination];
  const isActive = location.pathname === path;

  return children({
    isActive,
    navigate: () => routerNavigate({ to: path }),
  });
}
